<template>
  <div class="supplier">
    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>查詢</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form>
            <v-row>
              <v-col cols="12" md="3">
                <v-select
                  :items="categorySelect"
                  label="類別"
                  v-model="searchForm.categoryId"
                  item-text="text"
                  item-value="value"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="名稱"
                  v-model="searchForm.merchantName"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" align="right">
                <v-btn class="ma-2" :loading="loading" @click="handleSerach"
                  >查詢</v-btn
                >
                <v-btn class="ma-2" @click="handleClear">清除</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-data-table
      :disable-pagination="true"
      :headers="headers"
      :items="merchants"
      :items-per-page="-1"
      :hide-default-footer="true"
      :header-props="{ sortIcon: null }"
    >
      <template v-slot:top>
        <v-row style="margin-top: 5px">
          <v-col align="right">
            <router-link
              :to="{ name: 'merchantCreate' }"
                  class="text-decoration-none ma-2 v-btn v-btn--contained"
              >
              <v-icon>mdi-plus</v-icon>
            </router-link>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item="row">
        <tr>
          <td>{{ row.item.merchantName }}</td>
          <td>{{ row.item.merchantCode }}</td>
          <td>{{ getVoucherDisplayTypeText(row.item.displayType) }}</td>
          <td>
            <img :src="row.item.merchantPic" />
          </td>
          <td>
            <v-simple-checkbox
              @input="handleEditEnable(row.item)"
              :value="row.item.isEnable"
            />
          </td>
          <td>
            <router-link
              :to="{
                name: 'merchantEdit',
                params: { merchantId: row.item.merchantId },
              }"
              class="text-decoration-none"
              ><v-icon>mdi-lead-pencil</v-icon></router-link
            >
          </td>
          <td>
            <router-link
              :to="{
                name: 'storeList',
                params: { merchantId: row.item.merchantId },
              }"
              class="text-decoration-none"
            >
              <v-icon>mdi-store</v-icon>
            </router-link>
          </td>
          <td>
            <button @click.stop="handleOpenKeyDialog(row.item)">
              <v-icon>mdi-key-variant</v-icon>
            </button>
          </td>
          <td>
            <button @click.stop="handleToAnnouncement(row.item)">
              <v-icon color="blue darken-2">mdi-message-text</v-icon>
            </button>
          </td>

          <td>
            <button @click.stop="handleDelete(row.item.merchantId)">
              <v-icon>mdi-window-close</v-icon>
            </button>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-model="isKeyDialogVisible"
      width="500"
      @click:outside="handleCloseDialog"
    >
      <v-card>
        <v-card-title class="headline" style="justify-content: center">
          {{ dialogInfo.merchantName }} 加密金鑰
        </v-card-title>
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: flex-start;
            padding: 15px 25px;
            flex-direction: column;
          "
        >
          <dl>
            <dt>KEY:</dt>
            <dd>{{ dialogInfo.merchantKey }}</dd>
            <dt>IV:</dt>
            <dd>{{ dialogInfo.merchantIv }}</dd>
          </dl>
        </div>
        <div
          class="dialog-actions"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 5px;
          "
        >
          <v-btn
            color="green darken-1"
            width="150"
            text
            @click="handleCloseDialog"
            >關閉</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api';
import itemMixin from '@/minix/itemMixin';
import { mapState } from 'vuex';
import Swal from 'sweetalert2';

export default {
  mixins: [itemMixin],
  data() {
    return {
      panel: 0,
      loading: false,
      isEdit: false,
      isKeyDialogVisible: false,
      dialogInfo: {
        merchantCode: '',
        merchantKey: '',
        merchantIv: '',
      },
      searchForm: {
        categoryId: '',
        merchantName: '',
      },
      headers: [
        { text: '名稱', value: 'merchantName' },
        { text: '識別碼', value: 'merchantCode' },
        { text: '序號圖案', value: 'displayType' },
        { text: '供應商圖片', value: 'merchantPic', width: 100 },
        { text: '啟用', value: 'enable' },
        { text: '修改', value: 'edit' },
        { text: '店家管理', value: 'store' },
        { text: '加密金鑰', value: 'key' },
        { text: '公告設定', value: 'announcement' },
        { text: '刪除', value: 'delete' },
      ],
      merchants: [],
    };
  },
  computed: {
    ...mapState({
      voucherDisplayTypes: (state) => state.merchant.voucherDisplayTypes,
    }),
    categorySelect() {
      return [
        { text: '全部', value: '' },
        ...this.merchantCategories.map((p) => ({
          text: p.categoryName,
          value: p.categoryId,
        })),
      ];
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const { data } = await api.merchant.list(this.searchForm);
      this.merchants = data || [];
    },
    handleSerach() {
      this.loading = true;
      this.getList();
      this.loading = false;
    },
    handleClear() {
      this.searchForm = {
        categoryId: '',
        merchantName: '',
      };
      this.getList();
    },
    handleCloseDialog() {
      this.isKeyDialogVisible = false;
    },
    async handleEditEnable(item) {
      const { merchantId, isEnable } = item;
      const message = isEnable ? '停用' : '啟用';
      await Swal.fire({
        title: `您確定要${message}嗎?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { status } = await api.merchant.modifyStatus(
            merchantId,
            !isEnable,
          );
          if (status === 1) {
            await Swal.fire({ icon: 'success', title: `${message}成功` });
            await this.getList();
          } else {
            await Swal.fire({
              icon: 'warning',
              title: `${message}失敗，請聯繫系統管理員。`,
            });
          }
        }
      });
    },
    handleOpenKeyDialog(item) {
      this.dialogInfo = { ...item };
      this.isKeyDialogVisible = true;
    },
    async handleDelete(merchantId) {
      await Swal.fire({
        title: '您確定要刪除嗎?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { status } = await api.merchant.delete(merchantId);
          if (status === 1) {
            await Swal.fire({ icon: 'success', title: '刪除成功' });
            await this.getList();
          } else {
            await Swal.fire({
              icon: 'warning',
              title: '刪除失敗，請聯繫系統管理員。',
            });
          }
        }
      });
    },
    handleChangeKey() {
      this.handleCloseDialog();
    },
    handleToAnnouncement(row) {
      const id = row.merchantId;
      this.$router.push({
        name: 'merchantannouncement',
        params: { id },
      });
    },
    getVoucherDisplayTypeText(id) {
      return this.voucherDisplayTypes.filter((type) => type.value === id)[0]
        .text;
    },
  },
};
</script>

<style scoped lang="scss">
.color-block {
  width: 20px;
  height: 20px;
}
.supplier {
  img {
    width: 100%;
  }
}
</style>
